import { remove } from 'ramda';
import { onFormChange } from '../../../actions/form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { Dispatch } from 'redux';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {  Icon, Tooltip  } from "@mui/material";
import { toggleModal } from '../../../../ModalTest/actions';

interface TrProps extends ReduxComponentInterface {
	index: number;
	row: any;
	rowDislplayValues: any;
	wholeTableValues: any;
	headers: { key: string; id: string; type: string; label?: string }[];
	formInstanceId: string;
	isViewOnly: boolean;
	styles: object;
	name: string;
}

const ellipsis = (text: any, chars: number): any => {
	const displayValue = typeof text === 'string' ? text : '';
	const shortText = displayValue.substring(0, chars);

	const tooltipValue = displayValue
		.split(/\n/)
		.reduce(
			(acc: any[], line: any, idx: number) => [
				...acc,
				<React.Fragment key={idx}>
					<p>{line}</p>
					<hr />
				</React.Fragment>,
			],
			[<hr key="start" />]
		);

	if (shortText.length < displayValue.length) {
		return (
			<Tooltip
				enterDelay={1000}
				leaveDelay={100}
				title={<React.Fragment>{tooltipValue}</React.Fragment>}
				componentsProps={{
					tooltip: {
						sx: {
							padding: '0.8em',
							backgroundColor: '#ffffff',
							color: 'rgba(0, 0, 0, 0.87)',
							maxWidth: 600,
							fontSize: '1em',
							fontWeight: 'normal',
							border: '1px solid gray',
							'& hr': {
								borderTop: '1px solid #f0f0f0',
							},
							'& .tooltipLink': {
								cursor: 'help',
							},
						},
					},
				}}
			>
				<span style={{ cursor: 'help' }}>{shortText}...</span>
			</Tooltip>
		);
	}

	return <span>{displayValue}</span>;
};

class Tr extends React.PureComponent<TrProps> {
	onEditClick = (event: React.MouseEvent) => {
		event.preventDefault();
		const { actions, name, row, index, formInstanceId } = this.props;
		actions.toggleModal(
			true,
			`form${name}`,
			{
				data: row,
				index,
				isNew: false,
			},
			formInstanceId
		);
	};

	onDeleteClick = (event: React.MouseEvent) => {
		event.preventDefault();
		const { actions, name, wholeTableValues, index, formInstanceId } = this.props;
		actions.toggleModal(true, `${name}deleteTableItemModal`, {
			callback: () =>
				actions.onFormChange(formInstanceId, [name], remove(index, 1, wholeTableValues)),
		}, formInstanceId);
	};

	render() {
		const { index, row, headers, isViewOnly, rowDislplayValues } = this.props;

		return (
			<tr>
				{!isViewOnly && (
					<td>
						<div className="tableActionsCell">
							<Icon className="fas fa-trash-alt action-button-formtable" onClick={this.onDeleteClick} />
							<Icon className="fas fa-pen action-button-formtable" onClick={this.onEditClick} />
						</div>
					</td>
				)}
				{headers.map((header, cid) => {
					const key: string = header?.id || header?.key || '';
					const elementKey = `${key}-${index}-${cid}`;
					const displayValue = rowDislplayValues[key] ?? null;
					const value = row[key] ?? null;

					return (
						<td key={elementKey} className={!value ? 'tableNoValue' : ''}>
							{header?.type?.toLowerCase() === 'textareafield' ? (
								<span>{ellipsis(displayValue, 30)}</span>
							) : (
								<span>{displayValue}</span>
							)}
						</td>
					);
				})}
			</tr>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ toggleModal, onFormChange }, dispatch),
});

export default connect(null, mapDispatchToProps)(Tr);